import { ArticleGridBlock } from './article-grid.block'
import { ArticleCarousel, ArticleGrid } from '../../components'

export const ArticleGridComponent = (block: ArticleGridBlock) => {
  const articles = block.articles.slice(0, block.articleGridLimit)

  switch (block.articleGridDisplayStyle) {
    case 'carousel':
      return <ArticleCarousel articles={articles} imagePriority={block.imagePriority} />

    case 'grid':
      return <ArticleGrid articles={articles} imagePriority={block.imagePriority} />
    default:
      return null
  }
}
